module.exports = __webpack_public_path__ + "static/media/mix-match-view.58304f17.png";